import classnames from 'classnames';
import { useMemo } from 'react';

import type { AppState } from 'bootstrap.store';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { type Starter, useRegisterStarters } from 'utils/sidekickStarters';

import MessageSection from '../containers/messageSection';
import ReplySection from '../containers/replySection';

export const ConversationMessages = (): JSX.Element => {
  const { isFocusMode, requester, messages } = useAppSelector(
    (state: AppState) => ({
      isFocusMode: state.conversation.isFocusMode,
      requester: state.conversation.metaConversation.requester,
      messages: state.conversation.metaConversation.messages,
    }),
  );

  const hasBotAuthoredMessage = messages.some(
    (message) => message.author?.type === 'bot',
  );

  const starters = useMemo(
    () =>
      hasBotAuthoredMessage
        ? ([
            { label: 'Debug AI agent conversation' },
          ] as const satisfies readonly Starter[])
        : [],
    [hasBotAuthoredMessage],
  );

  useRegisterStarters(starters);

  return (
    <div
      className={classnames('content message-content scrollable', {
        'focus-mode': isFocusMode,
      })}
      style={{ padding: 0 }}
    >
      <MessageSection />

      {!requester?.anonymized_at && <ReplySection />}
    </div>
  );
};
